import logo from './logo.svg';
import './App.css';
import { createRef, useEffect, useState } from 'react';
import axios from 'axios';
import { library } from '@fortawesome/fontawesome-svg-core'
import { fas } from '@fortawesome/free-solid-svg-icons'
library.add(fas)
function App() {

	

	
		return (
			<Initialize />
		)
	
}

function Initialize(){
	const [tracks, setTracks] = useState([])
	const [name, setName] = useState(null)
	

	const TRACKS = [{"id":1,"title":"Flying Mario","game":1002},{"id":2,"title":null,"game":1003},{"id":3,"title":"Intro","game":1004},{"id":4,"title":"Title","game":1005},{"id":5,"title":"Underworld","game":1006},{"id":6,"title":"Jungle (The Amazon)","game":1007},{"id":7,"title":"Bein' Friends","game":1008},{"id":8,"title":"Intro","game":1009},{"id":9,"title":"World Select","game":1010},{"id":10,"title":"Character Select","game":1011},{"id":11,"title":"Vampire's Kiss","game":1012},{"id":12,"title":"Intro","game":1013},{"id":13,"title":"Title Screen","game":1014},{"id":14,"title":"Ukjent","game":1015},{"id":15,"title":"Stage 1","game":1016},{"id":16,"title":"Title Screen","game":1017},{"id":17,"title":"Title Screen","game":1018},{"id":18,"title":"Title Screen","game":1019},{"id":19,"title":"First stage","game":1020},{"id":20,"title":"Wind Scene","game":1021},{"id":21,"title":"Fanfare","game":1021},{"id":22,"title":"Overworld","game":1021},{"id":23,"title":"Main Theme","game":1022},{"id":24,"title":"Stickerbrush Symphony","game":1022},{"id":25,"title":"Aquatic Ambience","game":1023},{"id":26,"title":"Main Theme","game":1023},{"id":27,"title":"Main Theme","game":1024},{"id":28,"title":"Moon Theme","game":1007},{"id":29,"title":"The Battle","game":1025},{"id":30,"title":"Big Blue","game":1026},{"id":31,"title":"Main Menu","game":1026},{"id":32,"title":"Mute City","game":1026},{"id":33,"title":"Main theme","game":1027},{"id":34,"title":"Gourmet Race","game":1028},{"id":35,"title":"Ground Theme","game":1028},{"id":36,"title":"Opening Stage","game":1029},{"id":37,"title":"The Timeless Adventures of Mickey Mouse","game":1030},{"id":38,"title":"Main Theme","game":1031},{"id":39,"title":"Main Theme","game":1032},{"id":40,"title":"Stage 1","game":1033},{"id":41,"title":"Flight training","game":1034},{"id":42,"title":"Main Theme","game":1035},{"id":43,"title":"Poke Center","game":1035},{"id":44,"title":"Green Hill Zone","game":1036},{"id":45,"title":"Corneria","game":1037},{"id":46,"title":"Main Theme","game":1038},{"id":47,"title":"Guile's Theme","game":1039},{"id":48,"title":"Character Select","game":1040},{"id":49,"title":"Stage 1","game":1041},{"id":50,"title":"Koopa's Beach","game":1042},{"id":51,"title":"Main Theme","game":1042},{"id":52,"title":"Stage 1","game":1043},{"id":53,"title":"Opening","game":1013},{"id":54,"title":"Course Clear","game":1044},{"id":55,"title":"Underwater","game":1044},{"id":56,"title":"Athletic Theme","game":1045},{"id":57,"title":"Overworld 1","game":1045},{"id":58,"title":"Main Theme","game":1046},{"id":59,"title":"Theme 1","game":1047},{"id":60,"title":"Theme 2","game":1047},{"id":61,"title":"Stage 1","game":1048},{"id":62,"title":"Main Theme","game":1049},{"id":63,"title":"Sewer Surfing","game":1011},{"id":64,"title":"Main Menu","game":1050},{"id":65,"title":"Menu","game":1050}]
	const GAMES = [{"id":1002,"title":"Super Mario 64","console":"n64"},{"id":1003,"title":"1080 Snowboarding","console":"n64"},{"id":1004,"title":"Mega Man 3","console":"nes"},{"id":1005,"title":"OL Lillehammer 1994","console":"nes"},{"id":1006,"title":"Super Mario Bros.","console":"nes"},{"id":1007,"title":"Duck Tales","console":"nes"},{"id":1008,"title":"Earthbound","console":"nes"},{"id":1009,"title":"Thomas the Tank Engine","console":"nes"},{"id":1010,"title":"Super Mario Bros. 3","console":"nes"},{"id":1011,"title":"Turtles in Time","console":"snes"},{"id":1012,"title":"Castlevania: Dracula X","console":"snes"},{"id":1013,"title":"Super Mario RPG","console":"snes"},{"id":1014,"title":"Lemmings","console":"snes"},{"id":1015,"title":"Aladdin","console":"snes"},{"id":1016,"title":"Bart VS the World","console":"nes"},{"id":1017,"title":"Battle Toads","console":"snes"},{"id":1018,"title":"Biker Mice from Mars","console":"snes"},{"id":1019,"title":"Bubble Bobble 2","console":"nes"},{"id":1020,"title":"Chip 'n' Dale","console":"nes"},{"id":1021,"title":"Chrono Trigger","console":"snes"},{"id":1022,"title":"Donkey Kong Country 2","console":"snes"},{"id":1023,"title":"Donkey Kong Country","console":"snes"},{"id":1024,"title":"Dragon Quest VI","console":"snes"},{"id":1025,"title":"Final Fantasy V","console":"snes"},{"id":1026,"title":"F-ZERO","console":"snes"},{"id":1027,"title":"Killer Instinct","console":"snes"},{"id":1028,"title":"Kirby Super Star","console":"snes"},{"id":1029,"title":"Mega Man X","console":"snes"},{"id":1030,"title":"Mickey's Mania","console":"snes"},{"id":1031,"title":"NBA Jam","console":"snes"},{"id":1032,"title":"Nintendo World Cup","console":"nes"},{"id":1033,"title":"Paperboy","console":"nes"},{"id":1034,"title":"Pilotwings","console":"snes"},{"id":1035,"title":"Pokemon Red","console":"gb"},{"id":1036,"title":"Sonic The Hegdehog","console":"genesis"},{"id":1037,"title":"Star Fox","console":"snes"},{"id":1038,"title":"Star Wars","console":"snes"},{"id":1039,"title":"Street Fighter","console":"snes"},{"id":1040,"title":"Streets of Rage 2","console":"genesis"},{"id":1041,"title":"Super Mario Bros. 2","console":"snes"},{"id":1042,"title":"Super Mario Kart","console":"snes"},{"id":1043,"title":"Super Mario Land","console":"gb"},{"id":1044,"title":"Super Mario World","console":"snes"},{"id":1045,"title":"Super Mario World 2","console":"snes"},{"id":1046,"title":"Super Metroid","console":"snes"},{"id":1047,"title":"Super Soccer","console":"snes"},{"id":1048,"title":"Tetris","console":"gb"},{"id":1049,"title":"Tiny Toons Adventures","console":"snes"},{"id":1050,"title":"Zelda: A Link to the Past","console":"snes"}]	
	const URL = 'https://www.nerdelandslaget.no/assets/audio/bit-for-bit/';

	useEffect(() => {
		initializeTracks();
	}, []);


	const initializeTracks = () => {
		
		const allTracks = [];
		const usedIds = [];

		let i = 0;
		while (i <= 2) {
			
			const random = Math.floor(Math.random() * TRACKS.length);
			if(usedIds.includes(random)) continue;

			usedIds.push(random)
			let currentTrack = TRACKS[random];
			if(currentTrack){
				let obj = GAMES.find(o => o.id === currentTrack.game);
				currentTrack.gameObject = obj
				currentTrack.src = [
					{"url" : URL + currentTrack.id + '/step-1.wav'},
					{"url" : URL + currentTrack.id + '/step-2.wav'},
					{"url" : URL + currentTrack.id + '/step-3.wav'}
				]
			}

			const alternatives = [
				{
					"title": currentTrack.gameObject.title,
					"id": currentTrack.gameObject.id,
					"correct": true
				}
			]

			let k = 0;
			while(k <= 4){
				const r = Math.floor(Math.random() * GAMES.length);

				if(GAMES[r] === undefined) continue;
				
				let exists = alternatives.find(o => o.id === GAMES[r].id);

				if(exists) continue;

				alternatives.push({
					"title": GAMES[r].title,
					"id": GAMES[r].id,
					"corrent": false
				})

				k++;
			}
			
			currentTrack.alternatives = alternatives.sort((a, b) => 0.5 - Math.random());
			allTracks.push(currentTrack)

			i++;
		}
		
		setTracks(allTracks)
		
		
	}

	

	if(tracks.length !== 3){
		return (
			<h1>Loading</h1>
		)
	}

	

	if(name === null){
		return (<Intro setName={setName} />)
	}

	return (
		<Main tracks={tracks} name={name} initializeTracks={initializeTracks} />
  	);
}

function Intro({setName}){
	const [value, setValue] = useState('')
	const [showButton, setShowButton] = useState(false)
	const [start, setStart] = useState(false)
	const ref = createRef()
	const audioRef = createRef()
	const addLetter = (letter) => {
		setValue(value + letter)
	}

	useEffect(() => {
		
		if(value.length > 0){
			setShowButton(true)
		}else{
			setShowButton(false)
		}
	}, [value])

	useEffect(() => {
		
		if(audioRef.current){
			audioRef.current.volume = 0.2
			audioRef.current.load();
		}
		
	}, [])
	

	if(!start){
		return (
			<div className="d-flex flex-column app-container" style={{backgroundImage: `url('${process.env.PUBLIC_URL}/gfx/banner/background-details.jpg')`}}>
				<header className="col-auto">
					<audio ref={audioRef}>
						<source src={process.env.PUBLIC_URL + '/jingle.wav'} type="audio/wav" />
					</audio>
				</header>
				<main className="App-header col text-center">
					<img src={process.env.PUBLIC_URL + '/gfx/nl-logo-outline-upscaled.png'} className="logo mb-5" />
					<div className="bit-for-bit mb-5 text-center">
						<h1>BIT</h1>
						<h6>FOR</h6>
						<h1>BIT</h1>
					</div>
					<h2 className="blink_me" onClick={() => { setStart(true); 
				audioRef.current.play()}}>PRESS START</h2>
				</main>
			</div>
		)
	}

	return (
		<div className="d-flex flex-column app-container" style={{backgroundImage: `url('${process.env.PUBLIC_URL}/gfx/banner/background-details.jpg')`}}>
			<header className="col-auto">
				<audio ref={audioRef}>
					<source src={process.env.PUBLIC_URL + '/jingle.wav'} type="audio/wav" />
				</audio>
			</header>
			<main className="App-header col text-center">
					<div className="nes-field mb-4">
						<label>DITT NAVN</label>
						<input ref={ref} type="text" value={value} onChange={(e) => setValue(e.target.value)} className="nes-input text-center text-uppercase" maxLength={6} />
					</div>
					<div className="row">
						<Character value={'A'} addLetter={addLetter} />
						<Character value={'B'} addLetter={addLetter} />
						<Character value={'C'} addLetter={addLetter} />
						<Character value={'D'} addLetter={addLetter} />
						<Character value={'E'} addLetter={addLetter} />
						<Character value={'F'} addLetter={addLetter} />
						<Character value={'G'} addLetter={addLetter} />
					</div>
					<div className="row">
						<Character value={'H'} addLetter={addLetter} />
						<Character value={'I'} addLetter={addLetter} />
						<Character value={'J'} addLetter={addLetter} />
						<Character value={'K'} addLetter={addLetter} />
						<Character value={'L'} addLetter={addLetter} />
						<Character value={'M'} addLetter={addLetter} />
						<Character value={'N'} addLetter={addLetter} />
					</div>
					<div className="row">
						<Character value={'O'} addLetter={addLetter} />
						<Character value={'P'} addLetter={addLetter} />
						<Character value={'Q'} addLetter={addLetter} />
						<Character value={'R'} addLetter={addLetter} />
						<Character value={'S'} addLetter={addLetter} />
						<Character value={'T'} addLetter={addLetter} />
						<Character value={'U'} addLetter={addLetter} />
					</div>
					<div className="row">
						<Character value={'V'} addLetter={addLetter} />
						<Character value={'W'} addLetter={addLetter} />
						<Character value={'X'} addLetter={addLetter} />
						<Character value={'Y'} addLetter={addLetter} />
						<Character value={'Z'} addLetter={addLetter} />
						<Character value={'Æ'} addLetter={addLetter} />
						<Character value={'Ø'} addLetter={addLetter} />
					</div>
					<div className="row mb-3">
						<Character value={'Å'} addLetter={addLetter} />
						<Character value={'1'} addLetter={addLetter} />
						<Character value={'2'} addLetter={addLetter} />
						<Character value={'3'} addLetter={addLetter} />
						<Character value={'4'} addLetter={addLetter} />
						<Character value={'5'} addLetter={addLetter} />
						<Character value={'6'} addLetter={addLetter} />
					</div>
					{ showButton ? 
					<button type="button" className="nes-btn is-success" onClick={() => setName(value)}>Bit for Bit</button> 
					: <button type="button" className="nes-btn is-success is-disabled" disabled>Bit for Bit</button>}
					
			</main>
			
		</div>
	)
}

function Character({ value, addLetter }){
	return (
		<div className="col-auto">
			<h2 type="button" value={value} onClick={() => addLetter(value)}>{value}</h2>
		</div>
	)
}

function Main({ tracks, name, initializeTracks }){
	
	const [currentTrack, setCurrentTrack] = useState(0)
	const [showHighscores, setShowHighscores] = useState(false)
	const [step, setStep] = useState(0)
	const [playing, setPlaying] = useState(false)
	const [score, setScore] = useState(0)
	const [bonus, setBonus] = useState(1000);
	const [showCorrect, setShowCorrent] = useState(false)
	const [showError, setShowError] = useState(false)
	let timer;
	const audioRef = createRef()

	
	useEffect(() => {
		if(playing){
			startTimer()
		}
	})
	

	const startTimer = () => {
		
		timer = setTimeout(() => {
			if(bonus >= 1){
				setBonus(bonus - 1)
			}
		}, 50);

	}

	const play = () => {
		audioRef.current.play();
		setPlaying(true)
	}

	useEffect(() => {
		if(step === 3){
			setCurrentTrack(currentTrack + 1)
		}
	}, [step])

	useEffect(() => {
		if(!playing){
			if(audioRef.current){
				audioRef.current.load()
			}
		}
	}, [playing])

	useEffect(() => {
		if(showCorrect || showError){
			setTimeout(() => {
				setShowCorrent(false)
				setShowError(false)
			}, 3000)
		}
	}, [showCorrect, showError])

	useEffect(() => {
		clearTimeout(timer)
		setStep(0)
		if(currentTrack >= 3){
			setShowHighscores(true)
			setCurrentTrack(0)
		}
		setTimeout(() => {
			setBonus(1000)
		}, 100)
		
	}, [currentTrack])

	if(showCorrect || showError){
		return (
			<div className="d-flex flex-column app-container"  style={{backgroundImage: `url('${process.env.PUBLIC_URL}/gfx/banner/background-details.jpg')`}}>
			<header className="col-auto">
				<div className="p-3">
				<div className="row justify-content-between">
					<div className="col-auto text-center">
						<h5>Level <br />{currentTrack + 1}</h5>
					</div>
					<div className="col-auto text-center">
						<h5>Score <br/>{score}</h5>
					</div>
					<div className="col-auto text-center">
						<h5>Bonus <br/>{Math.abs(step - 3)}x</h5>
					</div>
				</div>
				</div>
			</header>
			<main className="App-header col" >
				{showCorrect ? (
					<div className="text-center correct-answer">
						<h1 className="text-uppercase">Riktig!</h1>
						<h2>Du har nå {score} poeng</h2>
					</div>
				) : (
					<div className="text-center correct-answer">
						<h1 className="text-uppercase">Feil!</h1>
						<h2>Synd, du klarte ikke denne :(</h2>
					</div>

				)}
				
			</main>
			<footer className="col-auto">
				<div className="px-md-3 pt-md-3 button-container">
					<div className="row">
						
					</div>
				</div>
			</footer>
		</div>
		)
	}

	
	if(showHighscores){
		return (
			<Highscores score={score} name={name} initializeTracks={initializeTracks} setShowHighscores={setShowHighscores} setScore={setScore} />
		)
	}

	const answer = (correct) => {
		if(audioRef.current){
			audioRef.current.pause();
		}
		setPlaying(false)

		if(correct){
			setShowCorrent(true)
			setScore((bonus * Math.abs(step - 3)) + score)
			setCurrentTrack(currentTrack + 1)
			
			
		}else{
			if(step === 2){
				setShowError(true)
			}
			setStep(step + 1)
		}
		

	}

	if(tracks[currentTrack] === undefined){
		return (
			<h1>Woooops</h1>
		)
	}
	const alternatives = tracks[currentTrack].alternatives

	return (
		<div className="d-flex flex-column app-container"  style={{backgroundImage: `url('${process.env.PUBLIC_URL}/gfx/banner/background-details.jpg')`}}>
			<header className="col-auto">
				<div className="p-3">
				<div className="row justify-content-between">
					<div className="col-auto text-center">
						<h5>Level <br />{currentTrack + 1}</h5>
					</div>
					<div className="col-auto text-center">
						<h5>Score <br/>{score}</h5>
					</div>
					<div className="col-auto text-center">
						<h5>Bonus <br/>{Math.abs(step - 3)}x</h5>
					</div>
				</div>
				</div>
			</header>
			<main className="App-header col" >
				
				<section className="icon-list">
					<img className="mx-1" src={process.env.PUBLIC_URL + '/gfx/heart.png'} />
					<img className="mx-1" src={process.env.PUBLIC_URL + (step > 1 ? '/gfx/heart-u.png' : '/gfx/heart.png') } />
					<img className="mx-1" src={process.env.PUBLIC_URL + (step > 0 ? '/gfx/heart-u.png' : '/gfx/heart.png') } />
				</section>
					

					
				
				{ tracks[currentTrack].src[step] !== undefined ? 
				(
					<div className="text-center">
						
						<audio ref={audioRef}>
							<source  src={tracks[currentTrack].src[step].url} type="audio/wav" />
							Your browser does not support the audio element.
						</audio>
						<div className=" my-md-4 my-2">
						<button onClick={play} disabled={playing} className="nes-btn is-success">Spill lyd {step + 1}</button>
						</div>
					</div>
				)
				: null}
				<h1>{bonus}</h1>
			</main>
			<footer className="col-auto">
				<div className="px-md-3 pt-md-3 button-container">
					<div className="row">
						{
							alternatives.map((item, index) => {
								return (
									<Button key={index} title={item.title} answer={answer} correct={item.correct} disabled={!playing} />
								)
							})
						}
					</div>
				</div>
			</footer>
		</div>
  	);
}

function Highscores({ score, name, initializeTracks, setShowHighscores, setScore }){

	const [highscores, setHighscores] = useState([])
	const [error, setError] = useState(false)

	useEffect(() => {
		axios.post('https://www.nerdelandslaget.no/api', {
			snippet: 'registerHighscore',
			name: name,
			score: score
		}).then((response) => {
			console.log(response.data)
			if(response.data.status === 1){
				setHighscores(response.data.data)
			}
		}).catch(() => {
			setError(true)
		})
	}, [])

	return (
		<div className="d-flex flex-column app-container" style={{backgroundImage: `url('${process.env.PUBLIC_URL}/gfx/banner/background-details.jpg')`}}>
			<header className="col-auto">
				<div className="p-3">
				<div className="row justify-content-center">
					<div className="col-auto">
						<h5>Score {score}</h5>
					</div>
				</div>
				</div>
			</header>
			<main className="App-header col">
				<h1>Highscores</h1>
				{
					error ? <h4>Noe gikk galt :(</h4> 
					: 
				
					
						highscores.length === 0 ? 
						(
							<h4>Loading...</h4>
						)
						:
						
						(
							<HighscoreItems highscores={highscores} />
							
							
						)
					
				}
				<button className="nes-btn" onClick={() => {
					setScore(0);
					initializeTracks();
					setShowHighscores(false);
				}}>Start på nytt!</button>
			</main>
			<footer className="col-auto">
				
			</footer>
		</div>
	)
}

function HighscoreItems({highscores}){
	return (
		<div className="container">
		<div className="row justify-content-between">
			<div className="col-auto">
				<h5>Navn</h5>
			</div>

			<div className="col-auto">
				<h5>Score</h5>
			</div>
		</div>
		{
			highscores.map((item, index) => {
				return (
					<div className="row justify-content-between">
						<div className="col-auto">
							<p>{item.name}</p>
						</div>
						<div className="col-auto">
							<p>{item.score}</p>
						</div>
					</div>
				)
			})
		}
		</div>
	)
}

function Button({ title, answer, correct, disabled }){
	return (
		<div className="col-lg-4 mb-md-3 mb-3">
			<button onClick={() => answer(correct)} type="button" className={(disabled ? "is-disabled" : "is-primary") + " nes-btn w-100 h-100"} disabled={disabled}>{title}</button>
		</div>
	)
}

export default App;
